import { cssGenerator, hooks } from '@yola/ws-sdk';
import customTools from 'src/js/modules/custom-tools';
import elementSettings from 'src/js/modules/element-settings';
import tools from './tools';
import settings from './settings';
import { SLUG, FLEX_BASIS_PROPERTY, MAX_WIDTH_PROPERTY, COLUMN_WIDTH_ATTRIBUTE } from './constants';

const extension = {
  slug: SLUG,
  title: 'WS Column',
  description: 'Extension for editing columns',
  defaults: {
    querySelector: 'ws-column',
    allowedBlockIds: 'custom',
  },
  ui: {
    control: [],
  },
  init() {
    elementSettings.operations.registerElementSettings(settings.getAllColumnsSettings());
    elementSettings.operations.registerElementSettings(settings.getThisColumnSettings());
    customTools.operations.registerTool(tools.columnResizeToolSettings);
    hooks.operations.subscribe(hooks.availableHooks.ON_BEFORE_CSS_GENERATOR_INIT, () => {
      const regex = new RegExp(`^${COLUMN_WIDTH_ATTRIBUTE}-([.\\d]+%*)$`);
      cssGenerator.generator.addRule(COLUMN_WIDTH_ATTRIBUTE, [
        regex,
        ([, num]) => ({ [FLEX_BASIS_PROPERTY]: `${num}`, [MAX_WIDTH_PROPERTY]: `${num}` }),
      ]);
    });
  },
};

export default extension;
